import Vue from "vue";
import store from "../store";
import axios from "axios";
// 環境變數 STA PROD
import constant from "../constant";
import router from "../router";
import tools from "../assets/js/tools";
Vue.use(tools);
import { sendLoginLog } from "@/apis/global/log.js";
let token = localStorage.getItem("token");

function setLoginLog() {
  const webType = router.app.$route.matched[0].name;

  let loginFrom = null;
  if (webType === "landlord") {
    loginFrom = "WEB_LANDLORD";
  } else if (webType === "bussiness") {
    loginFrom = "WEB_COMPANY";
  }

  const data = {
    loginFrom: loginFrom,
    model: Vue.prototype.getBrowser(),
    version: Vue.prototype.getSys()
  };
  sendLoginLog(data)
    .then(res => {})
    .catch(err => {
      console.log(err);
    });
}
function setTimestamp() {
  const date = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  const timestamp = localStorage.getItem("loginTime");
  if (timestamp) {
    if (date > timestamp) {
      localStorage.setItem("loginTime", date);
      setLoginLog();
    }
  } else {
    localStorage.setItem("loginTime", date);
    setLoginLog();
  }
}
// api host
export const baseDomain = constant.webApiUrl;
export const baseWebUrl = constant.webUrl;

// 測試用的Request設定
const testRequest = axios.create({
  baseURL: "http://192.168.50.63:2222/api/"
});
testRequest.defaults.headers.common = { Authorization: `bearer ${token}` };

// api base URl宣告
export const webRequest = axios.create({
  baseURL: baseDomain + "/api/"
});
// 提供不需要access token的 api
export const webNoTokenRequest = axios.create({
  baseURL: baseDomain + "/api/"
});
// 攔截登入api,更新token
webNoTokenRequest.interceptors.response.use(
  function(response) {
    if (response.data.status === "SUCCESS") {
      if (
        response.config.url == "/management/login" ||
        response.config.url == "/register/verification"
      ) {
        webRequest.defaults.headers.common = {
          Authorization: `bearer ${response.data.result.access_token}`
        };
      }
    } else if (response.data.status === "FAIL") {
      let reqParams;
      if (response.config.data) {
        reqParams = JSON.stringify(response.config.data);
      } else if (response.config.params) {
        reqParams = JSON.stringify(response.config.params);
      } else {
        reqParams = "none";
      }
      let data = {
        accessToken: response.config.headers.Authorization,
        channel: router.app.$route.meta.channel,
        apiUrl: response.config.url,
        reqParam: reqParams,
        errDesc: response.data.errorCode + ":" + response.data.errorMsg
      };
      console.log(data);
      store.dispatch("sendErrorLog", data);
      store.dispatch("setAlarmStatus", {
        status: true,
        title: response.data.errorMsg,
        type: "error"
      });
    }

    return response;
  },
  function(error) {
    // console.log('error', error.config)
    if (error.response) {
      // server responded status code falls out of the range of 2xx
      let reqParams;
      if (error.config.data) {
        reqParams = JSON.stringify(error.config.data);
      } else if (error.config.params) {
        reqParams = JSON.stringify(error.config.params);
      } else {
        reqParams = "none";
      }
      let data = {
        accessToken: token,
        channel: router.app.$route.meta.channel,
        apiUrl: error.config.url,
        reqParam: reqParams,
        errDesc: error.response.status
      };
      store.dispatch("sendErrorLog", data);

      switch (error.response.status) {
        case 400:
          break;
        case 401:
          break;
        case 404:
          // alert(`${error.response.status}: 資料來源不存在`)
          break;

        case 500:
          // alert(`${error.response.status}: 內部系統發生錯誤`)
          break;

        default:
          // alert(`${error.response.status}: 系統維護中，造成您的不便，敬請見諒。`)

          break;
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      if (
        error.code === "ECONNABORTED" &&
        error.message &&
        error.message.indexOf("timeout") !== -1
      ) {
        // request time out will be here
        // alert('網路連線逾時，請點「確認」鍵後繼續使用。')
      } else {
        // shutdonw api server
        // alert('網路連線不穩定，請稍候再試')
      }
    }

    return Promise.reject(error);
  }
);
// 設定全域access token
webRequest.defaults.headers.common = { Authorization: `bearer ${token}` };
webRequest.interceptors.request.use(
  async function(config) {
    setTimestamp();
    // 取得公司是否實名認證
    let verifiedStatus = store.getters.GET_BIZ_COMPANY_IS_VERIFIED;
    if (verifiedStatus == "UNDER_REVIEW" || verifiedStatus == "REJECT") {
      if (
        config.url == "/v1/oauth/management/role/authority/account" ||
        config.url == "/v1/oauth/management/edit" ||
        config.url == "/v1/oauth/management/company/info" ||
        config.url ==
          "/v1/oauth/management/company/image?imageType=AGENT_CERTIFICATE" ||
        config.url ==
          "/v1/oauth/management/company/image?imageType=ESTATE_SOCIETY" ||
        config.url ==
          "/v1/oauth/management/company/image?imageType=RENTAL_CERTIFICATE" ||
        config.url == "/oauth/user/check/member"
      ) {
        return config;
      }
    } else {
      return config;
    }
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 全局設定 AJAX Response 攔截器 (interceptor)
webRequest.interceptors.response.use(
  function(response) {
    if (response.data.status === "FAIL") {
      let reqParams;
      if (response.config.data) {
        reqParams = JSON.stringify(response.config.data);
      } else if (response.config.params) {
        reqParams = JSON.stringify(response.config.params);
      } else {
        reqParams = "none";
      }
      let data = {
        accessToken: response.config.headers.Authorization,
        channel: router.app.$route.meta.channel,
        apiUrl: response.config.url,
        reqParam: reqParams,
        errDesc: response.data.errorCode + ":" + response.data.errorMsg
      };
      console.log(data);
      store.dispatch("sendErrorLog", data);
    }
    return response;
  },
  function(error) {
    // console.log('error', error.config)
    if (error.response) {
      // server responded status code falls out of the range of 2xx
      let reqParams;
      if (error.config.data) {
        reqParams = JSON.stringify(error.config.data);
      } else if (error.config.params) {
        reqParams = JSON.stringify(error.config.params);
      } else {
        reqParams = "none";
      }
      let data = {
        accessToken: token,
        channel: router.app.$route.meta.channel,
        apiUrl: error.config.url,
        reqParam: reqParams,
        errDesc: error.response.status
      };
      store.dispatch("sendErrorLog", data);

      switch (error.response.status) {
        case 400:
          {
            const { message } = error.response.data;
            // alert(`${error.response.status}: ${message || '資料錯誤'}。`)
          }

          break;

        case 401:
          {
            const refreshTokeUrl = `${baseDomain}/api/getNewToken'`;
            console.log("refreshTokeUrl", refreshTokeUrl);
            // 當不是 refresh token 作業發生 401 才需要更新 access token 並重發
            // 如果是就略過此刷新 access token 作業，直接不處理(因為 catch 已經攔截處理更新失敗的情況了)
            if (error.config.url !== refreshTokeUrl) {
              // 原始 request 資訊
              const originalRequest = error.config;
              console.log("originalRequest", originalRequest);

              const data = {
                grant_type: "refresh_token",
                refresh_token: localStorage.getItem("refreshToken")
              };
              // 依據 refresh_token 刷新 access_token 並重發 request
              return apiRefreshTokeUrl(data) // refresh_toke is attached in cookie
                .then(response => {
                  // [更新 access_token 成功]
                  console.log("response", response);
                  // 刷新 storage (其他呼叫 api 的地方都會從此處取得新 access_token)
                  localStorage.setItem(
                    "token",
                    response.data.result.access_token
                  );

                  // 刷新原始 request 的 access_token
                  originalRequest.headers.Authorization =
                    "bearer " + response.data.result.access_token;
                  webRequest.defaults.headers.common = {
                    Authorization: `bearer ${response.data.result.access_token}`
                  };
                  // console.log('newToken', response.data.result.access_token)
                  // console.log('originalToken', token)
                  // console.log('localStorageToken', localStorage.getItem('token'))
                  // 重送 request (with new access_token)
                  return axios(originalRequest);
                })
                .catch(err => {
                  console.log("err", err);
                  // [更新 access_token 失敗] ( e.g. refresh_token 過期無效)
                  localStorage.setItem("token", "");

                  // alert(`${err.response.status}: 作業逾時或無相關使用授權，請重新登入`)
                  window.location.href = "/";
                  return Promise.reject(error);
                });
            }
          }

          break;

        case 404:
          // alert(`${error.response.status}: 資料來源不存在`)
          break;

        case 500:
          // alert(`${error.response.status}: 內部系統發生錯誤`)
          break;

        default:
          // alert(`${error.response.status}: 系統維護中，造成您的不便，敬請見諒。`)

          break;
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      if (
        error.code === "ECONNABORTED" &&
        error.message &&
        error.message.indexOf("timeout") !== -1
      ) {
        // request time out will be here
        // alert('網路連線逾時，請點「確認」鍵後繼續使用。')
      } else {
        // shutdonw api server
        // alert('網路連線不穩定，請稍候再試')
      }
    }

    return Promise.reject(error);
  }
);

// 多媒體API傳送格式
let imgConfig = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
};
let pdfConfig = {
  responseType: "arraybuffer"
};
let blobConfig = {
  responseType: "blob"
};

// 取得列表 api
export const apiGetCounty = () => webNoTokenRequest.get("/house/city/info");
export const apiGetDistrict = data =>
  webNoTokenRequest.get("/house/district?cityCid=" + data);
export const apiGetRoad = data =>
  webNoTokenRequest.get("/house/road?districtCid=" + data);

// User 相關的 api
export const apiUserRegister = data =>
  webNoTokenRequest.post("/register", data);
export const apiUserLogin = data =>
  webNoTokenRequest.post("/register/verification", data);
export const apiLandlordBinding = data =>
  webRequest.post("/lineChannel/oauth/landlord/bindUser", data);
export const apiCheckBinding = data =>
  webNoTokenRequest.post("/lineChannel/landlord/bindUserCheck", data);
export const apiRefreshTokeUrl = data =>
  webNoTokenRequest.post("/getNewToken", data);

// << 房東 相關的 api >>
// 房態Dashboard
export const apiGetDashboard = () =>
  webRequest.get("/oauth/house/manage/dashboard");
// 房態首頁
export const apiGetHouseStatus = () =>
  webRequest.get("/oauth/house/manage/status");
// 代簽合約
export const apiGetBeSignedContract = data =>
  webRequest.post("/oauth/order/pending/contracts", data);
// 拒絕租客
export const apiRejectContract = data =>
  webRequest.put(
    "/oauth/order/manage/contracts/reject?contractCid=" + data,
    null
  );
// export const apiRejectContract = data => webRequest.post('/oauth/task/contracts/reject', data);

// 預定
// 預定管理
export const apiGetBookingTableList = () =>
  webRequest.get("/oauth/order/booking/waiting/table/list");
// 預定管理-已結束
export const apiGetBookingFinishedTableList = () =>
  webRequest.get("/oauth/order/booking/conclude/table/list");

// 租約
// 租約管理-待租客確認
export const apiGetLeaseBeSigned = () =>
  webRequest.get("/oauth/order/manage/contracts/paper/list");
// 租約管理-已建立
export const apiGetLeaseDoneTableList = () =>
  webRequest.get("/oauth/order/manage/rent/agreement");
// 租約管理-已結束
export const apiGetLeaseFinishedTableList = () =>
  webRequest.get("/oauth/order/manage/contracts/finish/list");
// 房客歷史評價
export const apiGetHistoryRate = data =>
  webNoTokenRequest.post("/house/rate/history", data);
// 電子合約初始頁面
export const apiGetContract = data =>
  webRequest.get("/oauth/order/manage/contracts/initPage?contractCid=" + data);
// 新增電子合約
export const apiInsertContract = data =>
  webRequest.post("/oauth/order/manage/contracts/paper", data);
// 新增紙本合約-身分證
export const apiInsertContractIdImg = data =>
  webRequest.post(
    "/oauth/order/manage/contracts/paper/tenant/identity",
    data,
    imgConfig
  );
// 新增電子合約-紙本合約檔案
export const apiInsertContractFile = data =>
  webRequest.post(
    "/oauth/order/manage/contracts/paper/document/file",
    data,
    imgConfig
  );
// 新增電子合約-通知租客
export const apiNotifyTanant = data =>
  webRequest.post("/oauth/order/manage/contracts/notification", data);
// [租約管理] 刪除合約
export const apiDeleteContract = data =>
  webRequest.delete(
    "/oauth/order/manage/contracts/discard?contractCid=" + data
  );
// 退租資訊
export const apiGetContractReleaseInfo = data =>
  webRequest.get("/v2/oauth/order/manage/release/info", {
    params: { contractCid: data }
  });
// 退租點交
export const apiContractThrowLease = data =>
  webRequest.put(
    "/oauth/order/manage/contracts/release?contractCid=" + data,
    null
  );
// 取得合約詳細
export const apiGetContractHouse = data =>
  webRequest.get("/oauth/order/contracts/detail?contractCid=" + data);
// 取得合約v2
export const apiGetContractPaper = data =>
  webRequest.get("/oauth/order/contracts/html?contractCid=" + data);
// 取得合約PDF
export const apiGetContractPDF = data =>
  webRequest.get("/oauth/order/contracts/paper?contractCid=" + data, pdfConfig);
// 取得紙本待確認合約PDF
export const apiGetContractBeSignedPDF = data =>
  webRequest.get(
    "/oauth/order/contracts/getPaperContract?paperContractCid=" + data,
    blobConfig
  );
// 自動收租設定
export const apiSetAutoSendBill = data =>
  webRequest.post("/oauth/order/manage/contracts/set/autoSendBill", data);

// 房源
// 新增案件清單
export const apiGetInsertCaseList = () =>
  webRequest.get("/oauth/house/manage/case/insertDisplayPage");
// 建立房源
export const apiInsertHouse = data =>
  webRequest.post("/oauth/house/manage/case", data);
// 建立房源(無審核)
export const apiInsertHouseNoReview = data =>
  webRequest.post("/oauth/house/manage/notChecked/case", data);
// 上傳房源圖片
export const apiInsertHouseImage = data =>
  webRequest.post("/oauth/house/manage/case/houseImage", data, imgConfig);
// 上傳房源圖片v2
export const apiInsertHouseImageV2 = data =>
  webRequest.post("/oauth/house/manage/case/edit/images", data, imgConfig);
// 刪除房源圖片
export const apiDelHouseImage = data =>
  webRequest.delete("/oauth/house/manage/case/houseImage" + data, imgConfig);
// 編輯房源頁面
export const apiGetEditHouseList = data =>
  webRequest.get("/oauth/house/manage/case/editDisplayPage?houseCid=" + data);
// 刪除房源頁面
export const apiDelHouse = data =>
  webRequest.delete("/oauth/house/manage/case?houseCid=" + data);
// 上傳編輯房源頁面(有審核)
export const apiInsertEditHouse = data =>
  webRequest.put("/oauth/house/manage/case", data);
// 上傳編輯房源頁面(無審核)
export const apiInsertEditHouseNoReview = data =>
  webRequest.put("/oauth/house/manage/notChecked/case", data);
// 房源管理
export const apiGetHouseMgtList = () =>
  webRequest.get("/oauth/house/manage/source/list");
// 上傳批量房源照片
export const apiBatchHouse = data =>
  webRequest.post(
    "/oauth/house/manage/case/upload/package/images",
    data,
    imgConfig
  );
// 上傳批量EXCEL
export const apiBatchExcel = data =>
  webRequest.post("/oauth/house/manage/case/import/data", data, imgConfig);
// export const uploadExcel = data => webRequest.post('/v1/oauth/management/bill/uploadBatchCreateBillExcel', data, imgConfig);
// [案件] 房東政策設定頁面
export const apiGetLanlordPolicy = () =>
  webRequest.get("/oauth/house/manage/policySetting");
// [案件] 新增／修改 房東政策
export const apiEditLandlordPolicy = data =>
  webRequest.post("/oauth/house/manage/policySetting", data);
// [案件] 刪除房東政策
export const apiDeleteLandlordPolicy = data =>
  webRequest.delete("/oauth/house/manage/policySetting", {
    headers: { Authorization: "bearer " + token },
    data
  });
// 取得房源明細（與企業共用）
// export const apiGetHouseDetail = data => webNoTokenRequest.get('/v2/house/findtarget/details?houseCid='+data);
// 上下架房源
export const apiPublishHouse = data =>
  webRequest.post("/oauth/house/manage/publish", data);
// 取得房源評價
export const apiGetHouseRateComment = data =>
  webNoTokenRequest.get(
    "/house/houseRateList?houseCid=" + data.cid + "&page=" + data.page + ""
  );

// 會員中心
// 取得銀行總部名單
export const apiGetBankList = () => webRequest.get("/oauth/bank/lord/list");
// 取得銀行分行明單
export const apiGetBankBranchList = data =>
  webRequest.get("/oauth/bank/lord/branch/list?bankCode=" + data);
// 新增個人銀行帳戶
export const apiSaveBankCard = data =>
  webRequest.get(
    "/oauth/bank/create/account?bankCode=" +
      data.bank +
      "&branchCode=" +
      data.bankBranch +
      "&accountNo=" +
      data.account +
      "&accountName=" +
      data.name
  );
// 取得個人銀行帳戶
export const apiGetBankCard = () => webRequest.get("/oauth/bank/info");
// 設定預設個人銀行帳戶
export const apiSetDefaultBankCard = data =>
  webRequest.post("/oauth/bank/setDefaultAccount", data);
// 刪除個人銀行帳戶
export const apiDeleteBankCard = data =>
  webRequest.post("/oauth/bank/delete/account", data);
// 新增費用
export const apiInsertBill = data =>
  webRequest.post("/oauth/order/manage/contracts/bill", data);
// 取得新增費用期數
export const apiGetBillPeriods = data =>
  webRequest.get(
    "/oauth/order/manage/contracts/contractBillPeriods?contractCid=" + data
  );
// 取得帳戶餘額
export const apiGetBalance = () =>
  webRequest.get("/oauth/user/account/balance");
// 取得帳戶提領紀錄
export const apiGetTransRecord = page =>
  webRequest.get("/oauth/user/account/withdrawTransactions?page=" + page);
// 帳戶提領
export const apiWithwraw = data =>
  webRequest.post("/oauth/user/account/withdraw", data);
// 錢包扣款
export const apiWalletPayment = data =>
  webRequest.post("/oauth/user/account/payment", data);
// 儲值紀錄
export const apiGetStoredRecord = () =>
  webRequest.get("/oauth/user/financial/Stored/record");

// 設定用戶訊息
// export const apiSetUserInfo = () => webRequest.get('/oauth/user/auditdata');
// 取得用戶訊息
export const apiGetUserInfo = () => webRequest.get("/oauth/user/data");
// 設定用戶訊息
export const apiSetUserInfo = data =>
  webRequest.post("/oauth/user/auditdata", data);
// 設定用戶身分證
export const apiSetUserIdCard = data =>
  webRequest.post("/oauth/upload/idcard", data, imgConfig);
// 新增或編輯暱稱
export const apiSetNickName = data =>
  webRequest.post("/oauth/user/data/nickName?nickName=" + data, null);
// 設定個資編輯
export const apiSetUserPersonInfo = data =>
  webRequest.post("/oauth/user/data/information", data);
// 取得身分證照片
export const apiGetUserIdCard = data =>
  webRequest.get("/oauth/user/photo?userFileType=" + data, blobConfig);
// 設定大頭貼
export const apiSetUserShot = data =>
  webRequest.post("/oauth/upload/userAvatar", data);

// 查詢合約帳單清單
export const apiGetContractBill = data =>
  webRequest.get("/oauth/order/contracts/bill?contractCid=" + data);
// 收支列表
export const apiGetIncomeAndExpenditure = () =>
  webRequest.get("/oauth/user/financial/report");
// 收支情況
export const apiGetIncomeAndExpenditureStatistics = data =>
  webRequest.get("/oauth/user/financial/statistics?statisticsType=" + data);
// 應收與未繳
export const apiGetReceivable = data =>
  webRequest.get(
    "/oauth/user/financial/receivable/data?statisticsType=" + data
  );
// 入住率
export const apiGetOccupancyRate = () =>
  webRequest.get("/oauth/user/financial/occupancy/rate");
// 記帳本列表
export const apiGetLedgerData = () =>
  webRequest.get("/oauth/user/financial/getLedgerData");
// 新增及編輯記帳
export const apiAddOrUpdateLedger = data =>
  webRequest.post("/oauth/user/financial/addOrUpdateLedger", data);
// 刪除記帳
export const apiDeleteLedger = data =>
  webRequest.post("/oauth/user/financial/deleteLedgerData", data);
// 帳單列表
export const apiGetFinancialBill = () =>
  webRequest.get("/oauth/order/contracts/bill/all");
// 帳單刪除
export const apiDeleteBill = data =>
  webRequest.post("/oauth/order/manage/contracts/delete/bill", data);
// 設定已催款
export const apiHadSent = data =>
  webRequest.post("/oauth/order/contracts/set/isHadSent", data);

// 查詢帳單明細
export const apiGetBillDetail = data =>
  webRequest.get("/oauth/order/contracts/bill/detail?billCid=" + data);
// 查詢有合約租客
export const apiGetContractTenant = data =>
  webRequest.get("/oauth/order/contracts/tenant/data?contractCid=" + data);
// 發送推播
export const apiSendMsg = data => webRequest.post("/oauth/fcm/send", data);
// 取得欠款清單
export const apiGetUnpaidBill = data =>
  webRequest.get("/oauth/order/contracts/unpaidBill?contractCid=" + data);
// 取得尚未評價清單
export const apiGetUnEvaluation = data =>
  webRequest.get("/house/tenant/notEvaluated?houseCid=" + data);
// 新增房客評價
export const apiSetEvaluation = data =>
  webRequest.post("/oauth/order/manage/contracts/tenantRate", data);

// 委託
// 委託進行中
export const apiGetTaskProcess = page =>
  webRequest.get("/oauth/house/manage/task?page=" + page + "&type=IN_PROGRESS");
// 委託結束
export const apiGetTaskFinished = page =>
  webRequest.get("/oauth/house/manage/task?page=" + page + "&type=FINISH");
// 獎金虛擬帳號
export const apiGetVirtualAccount = data =>
  webRequest.get(
    "/oauth/house/manage/task/virtualaccount/bonus?taskCid=" + data
  );
// 查看委託細節
export const apiGetTaskDetail = data =>
  webRequest.get("/oauth/house/manage/task/detail?page=1&taskCid=" + data);
// 刪除委託
export const apiDeleteTask = data =>
  webRequest.delete("/oauth/house/manage/task", {
    headers: { Authorization: "bearer " + token },
    data
  });
// 取得受委託姓名
export const apiGetTasker = data =>
  webRequest.get("/oauth/house/manage/task/checkTaskTaker?userPhone=" + data);
// 新增房源委託
export const apiSetTask = data =>
  webRequest.post("/oauth/house/manage/task", data);
// 取得委託房源
export const apiGetTaskHouse = page =>
  webRequest.get("/oauth/house/manage/task/houseList?page=" + page);
// 取得委託詳情
export const apiGetWebTaskDetail = data =>
  webRequest.get("/oauth/house/task/data?taskSeq=" + data);

// 企業
// 註冊
export const apiBizRegister = data =>
  webNoTokenRequest.post("/management/register", data);
// 認證信驗證
export const apiBizCheckVerified = data =>
  webNoTokenRequest.post("/management/activate", data);
// 重發認證信
export const apiBizResendVerified = data =>
  webNoTokenRequest.post("/management/send/verify/mail", data);
// 登入
export const apiBizLogin = data =>
  webNoTokenRequest.post("/management/login", data);
// 發送重設密碼信件
export const apiBizResetPwdEmail = data =>
  webNoTokenRequest.post("/management/send/reset/mail", data);
// 重設密碼
export const apiBizResetPwd = data =>
  webNoTokenRequest.post("/management/reset/password", data);
// 企業認證
export const apiBizVerified = data =>
  webRequest.post("/v1/oauth/management/create", data, imgConfig);
// 編輯企業認證
export const apiBizEditVerified = data =>
  webRequest.post("/v1/oauth/management/edit", data, imgConfig);
// 取得企業認證資料
export const apiBizGetVerifiedInfo = () =>
  webRequest.get("/v1/oauth/management/company/info");

// 取得會員資料
export const apiBizGetUserInfo = () =>
  webRequest.get("/oauth/user/check/member");
// 取得角色功能權限設定
export const apiBizGetRoleAccess = () =>
  webRequest.get("/v1/oauth/management/role/authority/account");
// 個人中心
// 取得會員資料
export const apiBizGetPersonalInfo = () =>
  webRequest.get("/v1/oauth/management/personal/get/personalInformation");
// 變更密碼
export const apiBizMemberResetPwd = data =>
  webRequest.post("/v1/oauth/management/personal/changePassword", data);
// 取得簽名驗證碼
export const apiBizGetSignatureCode = () =>
  webRequest.get("/v1/oauth/management/user/signatureCode");
// 上傳簽名檔
export const apiBizUploadSignature = data =>
  webNoTokenRequest.post("/management/uploadSignature", data, imgConfig);
// 簽約帶入簽名設定
export const apiBizAutoSignSetting = data =>
  webRequest.post("/v1/oauth/management/personal/autoSignSetting", data);
// 取得簽名圖檔
export const apiBizGetSignatureImg = () =>
  webRequest.get("/oauth/user/signature");

//個人首頁
//我的首頁
//空房率
export const apiBizGetVacancyRate = () =>
  webRequest.get("/v1/oauth/management/homepage/getVacancyRate");
//業績量
export const apiBizGetPerformance = () =>
  webRequest.get("/v1/oauth/management/homepage/getPerformance");
//開發量
export const apiBizGetDevelop = () =>
  webRequest.get("/v1/oauth/management/homepage/getDevelopmentAmountInfo");
// 待辦清單-房源
export const apiBizGetTodoListHouse = data =>
  webRequest.get(
    "/v1/oauth/management/homepage/todo/houses?county=" +
      data.county +
      "&district=" +
      data.district +
      "&groupId=" +
      data.groupId +
      "&memberId=" +
      data.memberId
  );
// 待辦清單-預定
export const apiBizGetTodoListBooking = data =>
  webRequest.get(
    "/v1/oauth/management/homepage/todo/reservation?county=" +
      data.county +
      "&district=" +
      data.district +
      "&groupId=" +
      data.groupId +
      "&memberId=" +
      data.memberId
  );
// 待辦清單-租約
export const apiBizGetTodoListLease = data =>
  webRequest.get(
    "/v1/oauth/management/homepage/todo/lease?county=" +
      data.county +
      "&district=" +
      data.district +
      "&groupId=" +
      data.groupId +
      "&memberId=" +
      data.memberId
  );
// 待辦清單-委託
export const apiBizGetTodoListTask = data =>
  webRequest.get(
    "/v1/oauth/management/homepage/todo/task?county=" +
      data.county +
      "&district=" +
      data.district +
      "&groupId=" +
      data.groupId +
      "&memberId=" +
      data.memberId
  );
//取得待辦總數
export const apiBizGetTodoCount = () =>
  webRequest.get("/v1/oauth/management/homepage/todo/count");

// 待辦事項
// 房態
export const apiBizGetHouseStatus = () =>
  webRequest.get("/v1/oauth/management/house/status");
// 房源管理
// 建立房源
export const apiBizInsertHouse = data =>
  webRequest.post("/v1/oauth/management/house/createHouse", data);
// 新增案件清單
export const apiBizGetInsertCaseList = () =>
  webRequest.get("/oauth/house/manage/case/insertDisplayPage");
// 建立房源(無審核)
export const apiBizInsertHouseNoReview = data =>
  webRequest.post("v1/oauth/management/house/createHouse/notChecked", data);
// 上傳房源圖片
export const apiBizInsertHouseImage = data =>
  webRequest.post(
    "/v1/oauth/management/house/upload/houseImage",
    data,
    imgConfig
  );
// 上傳房源圖片v2
export const apiBizInsertHouseImageV2 = data =>
  webRequest.post("/oauth/house/manage/case/edit/images", data, imgConfig);
// 刪除房源圖片
export const apiBizDelHouseImage = data =>
  webRequest.delete(
    "/v1/oauth/management/house/delete/houseImage" + data,
    imgConfig
  );
// 取得編輯房源預設頁面
export const apiBizGetEditHouseList = data =>
  webRequest.get("/v1/oauth/management/house/getHouse?houseCid=" + data);
// 刪除房源頁面
export const apiBizDelHouse = data =>
  webRequest.delete("/v1/oauth/management/house/delete?houseCid=" + data);
// 上傳編輯房源頁面(有審核)
export const apiBizInsertEditHouse = data =>
  webRequest.put("/v1/oauth/management/house/updateHouse", data);
// 上傳編輯房源頁面(無審核)
export const apiBizInsertEditHouseNoReview = data =>
  webRequest.put("/v1/oauth/management/house/updateHouse/notChecked", data);
// 上傳批量房源照片
export const apiBizBatchHouse = data =>
  webRequest.post(
    "/v1/oauth/management/house/upload/houseImages",
    data,
    imgConfig
  );
// 上傳批量EXCEL
export const apiBizBatchExcel = data =>
  webRequest.post(
    "/v1/oauth/management/house/case/import/data",
    data,
    imgConfig
  );
// [案件] 房東政策設定頁面
export const apiBizGetLanlordPolicy = () =>
  webRequest.get("/v1/oauth/management/get/policySetting");
// [案件] 預設條款
export const apiBizGetDefaultPolicy = () =>
  webRequest.get("/v1/oauth/management/house/default/policy");
// [案件] 新增房東政策
export const apiBizInsertLandlordPolicy = data =>
  webRequest.post("/v1/oauth/management/create/policySetting", data);
// [案件] 修改房東政策
export const apiBizEditLandlordPolicy = data =>
  webRequest.post("/v1/oauth/management/update/policySetting", data);
// [案件] 刪除房東政策
export const apiBizDeleteLandlordPolicy = data =>
  webRequest.delete("/v1/oauth/management/delete/policySetting", {
    headers: { Authorization: "bearer " + token },
    data
  });
// 上下架房源
export const apiBizPublishHouse = data =>
  webRequest.post("/v1/oauth/management/house/publish", data);
// 批量政策列表
export const apiBizGetBatchPolicyList = () =>
  webRequest.get("/v1/oauth/management/house/policy/batch/list");
// 批量替換政策
export const apiBizUpdateBatchPolicy = data =>
  webRequest.post("/v1/oauth/management/house/policy/batch/update", data);
// 批量新增政策
export const apiBizCreateBatchPolicy = data =>
  webRequest.post("/v1/oauth/management/house/policy/batch/create", data);
// 批量清空政策
export const apiBizDeleteBatchPolicy = data =>
  webRequest.post("/v1/oauth/management/house/policy/batch/delete", data);
// 批量設定上架列表
export const apiBizGetBatchPublishList = () =>
  webRequest.get("/v1/oauth/management/house/publish/batch/list");
// 批量設定上架
export const apiBizUpdateBatchPublish = data =>
  webRequest.post("/v1/oauth/management/house/publish/batch/update", data);
// 批量指派房源列表
export const apiBizGetBatchDispatchList = () =>
  webRequest.get("/v1/oauth/management/house/assign/batch/list");
// 單一指派房源
export const apiBizSingelUpdateDispatch = data =>
  webRequest.post("/v1/oauth/management/house/assign/house", data);
// 批量替換房東
export const apiBizUpdateDispatchLandlord = data =>
  webRequest.post("/v1/oauth/management/house/assign/batch/landlord", data);
// 批量替換業務
export const apiBizUpdateDispatchSales = data =>
  webRequest.post("/v1/oauth/management/house/assign/batch/agent", data);

// 預定
// 預定管理
export const apiBizGetBookingTableList = () =>
  webRequest.get("/v1/oauth/management/booking/waitingList");
// 預定管理-已結束
export const apiBizGetBookingFinishedTableList = () =>
  webRequest.get("/v1/oauth/management/booking/concludedList");
// 代簽合約
export const apiBizGetBeSignedContract = data =>
  webRequest.post("/v1/oauth/management/booking/pendingList", data);
// 拒絕租客
export const apiBizRejectContract = data =>
  webRequest.put(
    "/v1/oauth/management/contract/rejectContract?contractCid=" + data,
    null
  );

// 租約
// 租約管理-待租客確認
// export const apiBizGetLeaseBeSigned = () => webRequest.get('/v1/oauth/management/contract/paperContracts');
// 租約管理-已建立
// export const apiBizGetLeaseProcessTableList = () => webRequest.get('/v1/oauth/management/contract/inProgressContracts');
// 租約管理-已結束
// export const apiBizGetLeaseFinishedTableList = () => webRequest.get('/v1/oauth/management/contract/finishedContracts');
// 退租資訊
export const apiBizGetContractReleaseInfo = data =>
  webRequest.get("/v1/oauth/management/contract/release/info", {
    params: { contractCid: data }
  });
// 電子合約初始頁面
export const apiBizGetContract = data =>
  webRequest.get(
    "/v1/oauth/management/contract/getContract?contractCid=" + data
  );
export const apiBizGetContractPeriod = data =>
  webRequest.get("/v2/oauth/order/manage/inprogress/period?houseCid=" + data);
// 新增電子合約
export const apiBizInsertEContract = data =>
  webRequest.post("/v1/oauth/management/contract/nonBooking", data, imgConfig);
// 電子合約-押金與帳單設定
export const apiBizEContractDepositAndBillSetting = data =>
  webRequest.post("/v1/oauth/management/contract/depositAndBillSetting", data);
// 電子合約-通知
export const apiBizEContractNotify = data =>
  webRequest.post("/v1/oauth/management/contract/nonBooking/notify", data);
// 電子合約初始頁面
export const apiBizGetAvailableHouse = () =>
  webRequest.get("/v1/oauth/management/house/option");
// 新增紙本合約
export const apiBizInsertContract = data =>
  webRequest.post("/v1/oauth/management/contract/paper", data);
// 刪除紙本合約
export const apiBizDelPaperContract = data =>
  webRequest.post("/v1/oauth/management/contract/delete/paperContract", data);
// 新增紙本合約簽名及廣告頁面
export const apiBizSetSignAndAd = data =>
  webRequest.post("/v1/oauth/management/contract/landlordSignContract", data);
// 確認合約(房東)
export const apiBizConfirmContract = data =>
  webRequest.put(
    "/oauth/order/manage/contracts/comfirm?contractCid=" + data,
    null
  );
// 新增紙本合約-身分證
export const apiBizInsertContractIdImg = data =>
  webRequest.post(
    "/v1/oauth/management/contract/paper/tenant/identity",
    data,
    imgConfig
  );
// 新增紙本合約-紙本合約檔案
export const apiBizInsertContractFile = data =>
  webRequest.post(
    "/v1/oauth/management/contract/paper/document/file",
    data,
    imgConfig
  );
// 新增紙本合約-通知租客
// export const apiBizNotifyTanant = data => webRequest.post('/v1/oauth/management/contract/notification', data);
// [租約管理] 刪除合約
export const apiBizDeleteContract = data =>
  webRequest.delete(
    "/v1/oauth/management/contract/discardContract?contractCid=" + data
  );
// 退租點交
export const apiBizContractThrowLease = data =>
  webRequest.post(
    "/v1/oauth/management/contract/releaseContract?contractCid=" + data,
    null
  );
// 取得合約詳細
export const apiBizGetContractHouse = data =>
  webRequest.get("/v1/oauth/management/contract/detail?contractCid=" + data);
// 取得合約v2
export const apiBizGetContractPaper = data =>
  webRequest.get(
    "/v1/oauth/management/contract/getContract?contractCid=" + data
  );
// 取得合約PDF
// export const apiBizGetContractPDF = data => testRequest.get('/v1/oauth/management/contract/getPaperContractByPaperContractCid?contractCid='+data, pdfConfig);
// export const apiBizGetContractPDF = data => webRequest.get('/v1/oauth/management/contract/getPaperContractByContractCid?contractCid='+data, pdfConfig);
// 取得紙本待確認合約PDF
// export const apiBizGetContractBeSignedPDF = data => webRequest.get('/v1/oauth/management/contract/getPaperContractByPaperContractCid?paperContractCid='+data, pdfConfig);
// 自動收租設定
export const apiBizSetAutoSendBill = data =>
  webRequest.post("/v1/oauth/management/contract/setAutoSendBill", data);
// 查詢有合約租客
export const apiBizGetContractTenant = data =>
  webRequest.get(
    "/v1/oauth/management/contract/getTenantInfo?contractCid=" + data
  );
// 新增房客評價
export const apiBizSetEvaluation = data =>
  webRequest.post("/v1/oauth/management/contract/rateTenant", data);
// 查看房客評價
export const apiBizGetEvaluation = data =>
  webRequest.get(
    "/v1/oauth/management/contract/tenant/rate?contractCid=" + data
  );
// 新增/編輯 合約設定
// export const apiBizSetContractSetting = data => webRequest.post('/v1/oauth/management/contract/setContractSetting', data);
// 取得合約設定資料
// export const apiBizGetContractSetting= data => webRequest.get('/v1/oauth/management/contract/getContractSetting');
// 預覽設定合約資料
// export const apiBizPreviewContractSetting = data => webRequest.post('/v1/oauth/management/contract/previewContractSetting', data);
// 批量通知列表
export const apiBizGetBatchNotifyList = () =>
  webRequest.get("/v1/oauth/management/contract/notificationSetting/list");
// 批量通知設定
export const apiBizUpdateBatchNotify = data =>
  webRequest.post(
    "/v1/oauth/management/contract/notificationSetting/batch",
    data
  );
// 自動收租設定
export const apiBizUpdateSendRent = data =>
  webRequest.post("/v1/oauth/management/contract/setAutoCreateBill", data);
// 自動提醒設定
export const apiBizUpdateNotify = data =>
  webRequest.post("/v1/oauth/management/contract/setSendRentNotify", data);
// 取得欠款清單
export const apiBizGetUnpaidBill = data =>
  webRequest.get("/v1/oauth/management/bill/unpaid?contractCid=" + data);

// 委託
// 委託進行中
export const apiBizGetTaskProcess = page =>
  webRequest.get(
    "/v1/oauth/management/task/getAll?page=" + page + "&type=IN_PROGRESS"
  );
// 委託結束
export const apiBizGetTaskFinished = page =>
  webRequest.get(
    "/v1/oauth/management/task/getAll?page=" + page + "&type=FINISH"
  );
// 委託待付款
export const apiBizGetTaskUnpaid = page =>
  webRequest.get(
    "/v1/oauth/management/task/getAll?page=" + page + "&type=UNPAID"
  );
// 獎金虛擬帳號
export const apiBizGetVirtualAccount = data =>
  webRequest.get("/v1/oauth/management/task/virtualaccount?taskCid=" + data);
// 查看委託細節
export const apiBizGetTaskDetail = data =>
  webRequest.get("/v1/oauth/management/task/detail?page=1&taskCid=" + data);
// 刪除委託
export const apiBizDeleteTask = data =>
  webRequest.delete("/v1/oauth/management/task/delete", {
    headers: { Authorization: "bearer " + token },
    data
  });
// 取得受委託姓名
export const apiBizGetTasker = data =>
  webRequest.get("/oauth/house/manage/task/checkTaskTaker?userPhone=" + data);
// 新增房源委託
export const apiBizSetTask = data =>
  webRequest.post("/v1/oauth/management/task/add", data);
// 取得委託房源
export const apiBizGetTaskHouse = page =>
  webRequest.get("/v1/oauth/management/task/houseList?page=" + page);
// 取得委託詳情
export const apiBizGetWebTaskDetail = data =>
  webRequest.get("/v1/oauth/management/task/data?taskSeq=" + data);
// 一件付款
export const apiBizPaymentAll = () =>
  webRequest.get("/v1/oauth/management/task/payment/all");
// 企業錢包付款
export const apiBizPayment = data =>
  webRequest.post("/v1/oauth/management/task/payment", data);
// 付款紀錄
export const apiBizGetTaskPaymentRecord = () =>
  webRequest.get("/v1/oauth/management/task/payment/list");
// 房東管理
// 取得房東列表
export const apiBizGetLandlordMgtList = () =>
  webRequest.get("/v1/oauth/management/landlord/list");
// 取得房東資料
export const apiBizGetLandlordInfo = data =>
  webRequest.get("/v1/oauth/management/landlord/detail?id=" + data);
// 刪除房東
export const apiBizDelLandlord = data =>
  webRequest.delete("/v1/oauth/management/landlord/delete?id=" + data);
// 新增房東
export const apiBizInsertLandlord = data =>
  webRequest.post("/v1/oauth/management/landlord/save", data);

// 報表概覽
// 收支列表
export const apiBizGetIncomeAndExpenditure = () =>
  webRequest.get("/v1/oauth/management/financial/report");
// 收支情況
export const apiBizGetIncomeAndExpenditureStatistics = data =>
  webRequest.get(
    "/v1/oauth/management/financial/statistics?statisticsType=" + data
  );
// 應收與未繳
export const apiBizGetReceivable = data =>
  webRequest.get(
    "/v1/oauth/management/financial/receivable/data?statisticsType=" + data
  );
// 入住率
export const apiBizGetOccupancyRate = () =>
  webRequest.get("/v1/oauth/management/financial/occupancy/rate");
// 收支統計
export const apiBizGetFinancialIncome = data =>
  webRequest.get("/v1/oauth/management/financial/record?groupId=" + data);
// 收入排名
export const apiBizGetFinancialRanking = () =>
  webRequest.get("/v1/oauth/management/financial/ranking");

//帳單管理
// 帳單列表
// export const apiBizGetFinancialBill = () =>
//   webRequest.get("/v1/oauth/management/bill/record");
// export const apiBizGetFinancialBillV2 = () =>
//   webRequest.get("/v2/oauth/management/bill/record");
// 帳單刪除
export const apiBizDeleteBill = data =>
  webRequest.post("/v1/oauth/management/bill/delete", data);
// 設定已催款
export const apiBizHadSent = data =>
  webRequest.post("/v1/oauth/management/bill/set/isHadSent", data);
// 查詢帳單明細
export const apiBizGetBillDetail = data =>
  webRequest.get("/v1/oauth/management/bill/record/detail?billSeq=" + data);
// 查詢合約帳單清單
export const apiBizGetContractBill = data =>
  webRequest.get("/v1/oauth/management/bill/list?contractCid=" + data);
//屋主報表
// 屋主報表
export const apiBizGetlandlordReport = data =>
  webRequest.get(
    "/v1/oauth/management/financial/landlordStatement?year=" +
      data.year +
      "&month=" +
      data.month
  );
// 屋主報表細項
export const apiBizGetlandlordReportDetail = data =>
  webRequest.get("/v1/oauth/management/financial/landlordStatementDetail", {
    params: data
  });
// 更新對帳狀態
// export const apiBizUpdateReconcileStatus = data => webRequest.post('/v1/oauth/management/financial/updateReconcileStatus', data);
// 屋主月對帳單下載
// export const apiBizGetlandlordReportExcel = data => webRequest.get('/v1/oauth/management/landlord/getLandlordMonthlyStatement?fileId='+data, blobConfig);
// 取得屋主報表年月清單
export const apiBizGetlandlordReportDate = () =>
  webRequest.get("/v1/oauth/management/financial/statementYearMonths");
// 產生對帳單(產生試算)
export const apiBizLandlordMonthlyStatement = data =>
  webRequest.post("/v1/oauth/management/financial/computeStatement", data);

//記帳本管理
// 記帳本列表
// export const apiBizGetLedgerData = data => webRequest.get('/v1/oauth/management/ledger/getData?statisticsType='+data);
// 新增
// export const apiBizAddLedger = data => webRequest.post('/v1/oauth/management/ledger/add', data);
// 編輯記帳
// export const apiBizUpdateLedger = data => webRequest.post('/v1/oauth/management/ledger/update', data);
// 刪除記帳
// export const apiBizDeleteLedger = data => webRequest.post('/v1/oauth/management/ledger/delete', data);
// 取得記帳項目
// export const apiBizGetLedgerItem = data => webRequest.get('/v1/oauth/management/ledger/item?ledgerType='+data);
// 取得記帳專屬房源列表
// export const apiBizGetLedgerItem = data => webRequest.get('/v1/oauth/management/ledger/item?ledgerType='+data);

// 內部權限
// 取得業務分群列表
export const apiBizGetOrganizationGroupList = () =>
  webRequest.get("/v1/oauth/management/group/list");
// 取得單一業務分群
export const apiBizGetOrganizationGroupInfo = data =>
  webRequest.get("/v1/oauth/management/group/info?groupId=" + data);
// 新增業務分群
export const apiBizInsertOrganizationGroup = data =>
  webRequest.post("/v1/oauth/management/group/create", data);
// 編輯業務分群
export const apiBizEditOrganizationGroup = data =>
  webRequest.put("/v1/oauth/management/group/edit", data);
// 刪除業務分群
export const apiBizDelOrganizationGroup = data =>
  webRequest.delete("/v1/oauth/management/group/delete?groupId=" + data);
// 取得權限空列表
export const apiBizGetAuthEmptyList = () =>
  webRequest.get("/v1/oauth/management/role/authority/list/get");
// 取得企業角色列表
export const apiBizGetEmployeeRoleList = () =>
  webRequest.get("/v1/oauth/management/role/list");
// 取得單一企業角色
export const apiBizGetEmployeeRoleInfo = data =>
  webRequest.get("/v1/oauth/management/role/data?roleId=" + data);
// 新增企業角色
export const apiBizInsertEmployeeRole = data =>
  webRequest.post("/v1/oauth/management/role/authority/create", data);
// 編輯企業角色
export const apiBizEditEmployeeRole = data =>
  webRequest.post("/v1/oauth/management/role/authority/edit", data);
// 刪除企業角色
export const apiBizDelEmployeeRole = data =>
  webRequest.delete("/v1/oauth/management/role/delete?roleId=" + data);
// 取得帳號列表
export const apiBizGetAccountList = () =>
  webRequest.get("/v1/oauth/management/get/all/employee");
// 取得單一帳號
export const apiBizGetAccountInfo = data =>
  webRequest.get("/v1/oauth/management/get/employee?employeeCid=" + data);
// 新增帳號
export const apiBizInsertAccount = data =>
  webRequest.post("/v1/oauth/management/add/employee", data);
// 編輯帳號
export const apiBizEditAccount = data =>
  webRequest.post("/v1/oauth/management/edit/employee", data);
// 刪除帳號
export const apiBizDelAccount = data =>
  webRequest.delete("/v1/oauth/management/delete/employee?employeeCid=" + data);

// 取得房東列表
export const apiBizGetLandlordList = () =>
  webRequest.get("/v1/oauth/management/house/list/landlord");
// 建立房東
export const apiBizSetLandlord = data =>
  webRequest.post("/v1/oauth/management/house/create/landlord", data);
// 取得分群員工列表
export const apiBizGetMemberByGroup = data =>
  webRequest.get("/v1/oauth/management/user/getMemberByGroup", {
    params: { groupId: data }
  });

// 飛豬錢包
// 新增企業銀行帳戶
export const apiBizSaveBankCard = data =>
  webRequest.get(
    "/v1/oauth/management/wallet/create/account?bankCode=" +
      data.bank +
      "&branchCode=" +
      data.bankBranch +
      "&accountNo=" +
      data.account +
      "&accountName=" +
      data.name
  );
// 取得企業銀行帳戶
export const apiBizGetBankCard = () =>
  webRequest.get("/v1/oauth/management/wallet/bank/info");
// 設定預設企業銀行帳戶
export const apiBizSetDefaultBankCard = data =>
  webRequest.post("/v1/oauth/management/wallet/bank/setDefaultAccount", data);
// 刪除企業銀行帳戶
export const apiBizDeleteBankCard = data =>
  webRequest.post("/v1/oauth/management/wallet/delete/account", data);
// 取得收益紀錄
export const apiBizGetIncome = () =>
  webRequest.get("/v1/oauth/management/financial/report");
// 取得儲值帳號
export const apiBizGetWalletAccount = () =>
  webRequest.get("/v1/oauth/management/wallet/account/info");
// 取得儲值紀錄
export const apiBizGetStoredRecord = () =>
  webRequest.get("/v1/oauth/management/wallet/stored/record");
// 取得全部交易紀錄
export const apiBizGetAllTransRecord = data =>
  webRequest.get(
    "/v1/oauth/management/wallet/transactions?type=" +
      data.withdraw +
      "&origin=" +
      data.item +
      "&startTime=" +
      data.period[0] +
      "&endTime=" +
      data.period[1]
  );
// 提領
export const apiBizWithdraw = data =>
  webRequest.post("/v1/oauth/management/wallet/withdraw", data);
// 取得提領紀錄
export const apiBizGetWithdrawRecord = data =>
  webRequest.get(
    "/v1/oauth/management/wallet/withdrawTransactions?page=" +
      data.page +
      "&status=" +
      data.status +
      "&startTime=" +
      data.period[0] +
      "&endTime=" +
      data.period[1]
  );
// 查看錢包
export const apiBizGetWallet = () =>
  webRequest.get("/v1/oauth/management/wallet/balance");
// 新增費用
// export const apiBizInsertBill = data => webRequest.post('/v1/oauth/management/bill/create', data);
// 取得新增費用期數
// export const apiBizGetBillPeriods = data => webRequest.get('/v1/oauth/management/bill/contracts/contractBillPeriods?contractCid='+data);
// 取得收入或支出項目
export const apiBizGetTransationType = data =>
  webRequest.get(
    "/v1/oauth/management/wallet/income/list?transactionType=" + data
  );

// 關於企業
// 取得企業關於我
export const apiBizGetCompanyIntro = () =>
  webRequest.get("/v1/oauth/management/user/get/introduction");
// 新增編輯企業關於我
export const apiBizSetCompanyIntro = data =>
  webRequest.post("/v1/oauth/management/user/set/introduction", data);
// 取得企業相關圖片
// export const apiBizGetCompanyImages  = data => testRequest.get('/config/pdf?imageType='+data, pdfConfig);
export const apiBizGetCompanyImages = data =>
  webRequest.get(
    "/v1/oauth/management/company/image?imageType=" + data,
    blobConfig
  );
// 上傳大頭照
export const apiBizSetCompanyShot = data =>
  webRequest.post("/v1/oauth/management/company/avatar", data);

//電子發票
//取得電子發票清單
export const apiBizGetEinvoiceList = data =>
  webRequest.get(
    "/v1/oauth/management/invoice/list?year=" +
      data.year +
      "&month=" +
      data.month
  );
//下載發票
export const apiBizGetEinvoicePDF = data =>
  webRequest.get(
    "/v1/oauth/management/get/invoice?invoiceNumber=" + data,
    blobConfig
  );
//電子發票年份清單
export const apiBizGetEinvoiceYear = () =>
  webRequest.get("/v1/oauth/management/invoice/year/list");

// 問與答
export const apiBizFaqList = () =>
  webRequest.get("/v1/oauth/management/faq/enabledList");

// 房客頁面
export const apiTenantGetCompanyImages = data =>
  webNoTokenRequest.get(
    "/management/company/avatar?houseCid=" + data,
    blobConfig
  );

// 公告列表
export const apiBizAnnouncementList = () =>
  webNoTokenRequest.get("/management/announcementList");
// 取得房源組態
export const apiHouseConfig = () =>
  webNoTokenRequest.get("/config/getHouseConfigData");

//分享房源
// 預覽合約
export const apiShareHousePreviewContract = data =>
  webNoTokenRequest.get("/v2/house/preview/default/contract", { params: data });



// WEBPACK FOOTER //
// ./src/apis/api.js